import { useRef } from 'react';
import styles from './RadioItem.module.scss.js';
import cx from 'classnames';
import { jsxs, jsx } from 'react/jsx-runtime';

const RadioItem = ({
  label,
  selectedOption,
  setDropdownOpen,
  setSelectedOption,
  className,
  labelAdditional,
  dataTestId,
  onChange
}) => {
  const containerRef = useRef(null);
  const isSelectedOption = label === selectedOption.label;
  const handleChange = () => {
    setSelectedOption({
      label,
      labelAdditional
    });
    if (onChange) {
      onChange();
    }
  };
  const handleClick = (e) => {
    if (e.type === "click") {
      const clickEvent = e;
      if (clickEvent.clientX !== 0 && clickEvent.clientY !== 0) {
        setDropdownOpen(false);
      }
    }
  };
  const labelContent = `${label} ${labelAdditional ? ` (${labelAdditional})` : ""}`;
  return /* @__PURE__ */ jsxs("label", {
    className: cx(styles.label, className),
    ref: containerRef,
    children: [/* @__PURE__ */ jsx("input", {
      "data-test-id": dataTestId,
      role: "option",
      "aria-selected": isSelectedOption,
      className: styles.input,
      type: "radio",
      name: "radio",
      onChange: handleChange,
      onClick: handleClick,
      defaultChecked: isSelectedOption
    }), labelContent]
  });
};

export { RadioItem as default };
//# sourceMappingURL=RadioItem.js.map
